import { Link } from "react-router-dom";
import { Phone, ArrowUpRight, HelpCircle } from "lucide-react";
import {
    Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Overline } from "@/components/Section";
import HeroArtisanImage from "@/components/HeroArtisanImage";
import FAQ from "@/data/faq";

const FAQPage = () => {
    return (
        <>
            <section className="relative border-b border-black/10 grid-bg" data-testid="faq-hero">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 lg:pt-20 pb-14 lg:pb-16">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
                        <div className="lg:col-span-7 fade-up fade-up-1">
                            <Overline className="mb-5">◉ Foire aux questions</Overline>
                            <h1 className="font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
                                Toutes les réponses<br /><span className="text-[#E63946]">avant d'appeler.</span>
                            </h1>
                            <p className="mt-7 text-base sm:text-lg text-zinc-600 leading-relaxed max-w-2xl">
                                Tarifs, délais, garanties, types de serrures, paiement, assurances : retrouvez ici
                                les questions les plus fréquentes posées à Atelier Beauchamp. Si votre question
                                n'y figure pas, appelez-nous directement au 06 49 50 18 43.
                            </p>
                            <div className="mt-9 flex flex-col sm:flex-row gap-3">
                                <a
                                    href="tel:+33649501843"
                                    data-testid="faq-call-btn"
                                    className="inline-flex items-center justify-between gap-4 bg-[#E63946] hover:bg-[#D62828] text-white px-6 py-4 transition-colors"
                                >
                                    <span className="flex items-center gap-3">
                                        <Phone className="h-5 w-5" strokeWidth={2.4} />
                                        <span className="font-display font-bold text-lg tracking-tight">06 49 50 18 43</span>
                                    </span>
                                    <ArrowUpRight className="h-5 w-5" />
                                </a>
                                <Link
                                    to="/contact"
                                    className="inline-flex items-center justify-between gap-4 bg-[#0A0A0A] text-white px-6 py-4 hover:bg-zinc-800 transition-colors"
                                >
                                    <span className="font-semibold text-sm uppercase tracking-[0.15em]">Devis gratuit</span>
                                    <ArrowUpRight className="h-5 w-5" />
                                </Link>
                            </div>
                        </div>
                        <div className="lg:col-span-5 fade-up fade-up-2">
                            <HeroArtisanImage />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-16 lg:py-24 bg-white border-b border-black/10">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-semibold text-zinc-500 mb-8">
                        <HelpCircle className="h-3.5 w-3.5 text-[#E63946]" strokeWidth={2.6} />
                        {FAQ.length} questions fréquentes
                    </div>

                    <Accordion type="single" collapsible className="border-t border-b border-black/10">
                        {FAQ.map((it, i) => (
                            <AccordionItem
                                key={it.q}
                                value={`q-${i}`}
                                className="border-b border-black/10 last:border-b-0 px-1"
                                data-testid={`faq-page-item-${i}`}
                            >
                                <AccordionTrigger className="text-left font-display font-bold uppercase text-base sm:text-lg tracking-tight py-6 hover:no-underline hover:text-[#E63946]">
                                    {it.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-base text-zinc-600 leading-relaxed pb-6 pr-8 max-w-3xl">
                                    {it.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>

                    <div className="mt-14 p-7 sm:p-10 border border-black/10 bg-[#FAFAFA] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
                        <div>
                            <div className="text-xs uppercase tracking-[0.22em] font-semibold text-zinc-500 mb-2">◉ Une autre question ?</div>
                            <div className="font-display font-bold uppercase text-2xl tracking-tight">Appelez-nous, on vous répond.</div>
                        </div>
                        <a
                            href="tel:+33649501843"
                            data-testid="faq-bottom-call"
                            className="inline-flex items-center gap-3 bg-[#E63946] hover:bg-[#D62828] text-white px-6 py-4 transition-colors"
                        >
                            <Phone className="h-4 w-4" strokeWidth={2.4} />
                            <span className="font-display font-bold tracking-tight">06 49 50 18 43</span>
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FAQPage;
